import { render, staticRenderFns } from "./sysuser_auth_copy.vue?vue&type=template&id=036b1b4e&scoped=true"
import script from "./sysuser_auth_copy.vue?vue&type=script&lang=js"
export * from "./sysuser_auth_copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b1b4e",
  null
  
)

export default component.exports